import { ViewPortBreakpoint } from "../../domain/view-port/view-port-breakpoints.js";
import { useCoreDispatch, useCoreSelector } from "../../redux/config.js";
import { selectViewPort } from "../../redux/view-port/selectors.js";
import { updateViewPort } from "../../redux/view-port/thunks/update-view-port.js";
import { useEffect } from "react";
//#region src/presentation/hooks/use-view-port.ts
var resolveBreakpoint = (width) => {
	if (width <= ViewPortBreakpoint.SMARTPHONE) return ViewPortBreakpoint.SMARTPHONE;
	if (width <= ViewPortBreakpoint.TABLET) return ViewPortBreakpoint.TABLET;
	return ViewPortBreakpoint.DESKTOP;
};
var useViewPort = () => {
	const dispatch = useCoreDispatch();
	const viewPort = useCoreSelector(selectViewPort());
	useEffect(() => {
		const onResize = () => {
			const rect = window.document.body.getBoundingClientRect();
			dispatch(updateViewPort({
				width: rect.width,
				height: rect.height
			}));
		};
		window.addEventListener("resize", onResize);
		onResize();
		return () => {
			window.removeEventListener("resize", onResize);
		};
	}, [dispatch]);
	return viewPort;
};
//#endregion
export { resolveBreakpoint, useViewPort };

//# sourceMappingURL=use-view-port.js.map